import { INewReview } from '../../types/newReview';
import { INewReviewsSecondStepOpen } from '../../types/newReview/analytics';

export const prepareNewReviewsSecondStepOpen = (newReview: INewReview): INewReviewsSecondStepOpen => {
  return {
    total: newReview.data.generalRating.value,
    ecology: newReview.data.ecologyRating.value,
    infrastructure: newReview.data.infrastructureRating.value,
    price_quality: newReview.data.priceAndQualityBalanceRating.value,
    transport: newReview.data.transportRating.value,
  };
};
